<template>
    <b-container fluid>
       <b-row>
          <b-col sm="12">
               <card>
                  <template v-slot:headerTitle>
                        <h4 class="card-title">Existing Accessories and Spare Parts</h4>
                  </template>
                  <template v-slot:headerAction>
                     <div class="float-right">
                        
                        <router-link :to="{name: 'accessories.add'}" class="btn btn-primary" >Add Accessory</router-link>
                     </div>
                  </template>
                  <template v-slot:body>                     

                     <!----- Listing length and search starts ----->
                     <div class="row">
                        <div class="col-sm-12 col-md-6">
                           <div>
                              <label>Show 
                                 <select class="form-control" v-model="listing_length" @change="fetchAccessories()">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>    
                                 </select> entries
                              </label>
                           </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                           <div class="div-search">
                              <label>
                                 <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchAccessories()">
                              </label>
                           </div>
                        </div>
                     </div>
                     <!----- Listing length and search ends ----->

                     <!--- Listing starts ----->
                     <div class="table-responsive">
                        <table id="datatable" class="table data-table table-striped table-bordered dataTable" >
                           <thead>
                              <tr>
                                 <th>Image</th>
                                 <th>Title</th>
                                 <th>Price</th>                    
                                 <th>Status</th>
                                 <th>Options</th>                                 
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="accessory in accessories" :key="accessory.id">
                                 <td><img v-if="accessory.image" :src="$image_url + accessory.image" alt="Image not found" style="width:100px"></td>
                                 <td>{{accessory.title}}</td>
                                 <td>Rs. {{accessory.price}}</td>
                                 <td>
                                    
                                    <label v-if="accessory.status==0">Blocked</label>
                                    <label v-if="accessory.status==1">Active</label>
                                    <label v-if="accessory.status==2">Requested</label>
                                    <label v-if="accessory.status==3">Rejected</label>
                                    <label v-if="accessory.status==4">Sold</label>
                                    
                                 </td>
                                 <td>
                                    <router-link :to="{name: 'accessories.show', params: { id: accessory.id }}" class="btn btn-sm btn-primary mt-2 mr-1" >View</router-link>

                                    <!-- <router-link :to="{name: 'accessories.clicks', params: { id: accessory.id }}" class="btn btn-sm btn-primary mt-2 mr-1" >{{accessory.clicks}} Clicks <i class="fas fa-angle-double-right"></i></router-link> -->

                                    <a href="#" class="btn btn-sm btn-primary mt-2 mr-1" @click.prevent="setBackURL(accessory.id)">{{accessory.clicks}} Clicks <i class="fas fa-angle-double-right"></i></a>

                                    <router-link :to="{name: 'accessories.edit', params: { id: accessory.id }}" class="btn btn-sm btn-primary mt-2 mr-1" >Edit</router-link>

                                    <b-button variant="success" class="mt-2 mr-1 btn-sm" @click="approveVehicle(accessory)" v-if="accessory.status==2">Approve</b-button> 

                                    <b-button variant="danger" class="mt-2 mr-1 btn-sm" @click="rejectVehicle(accessory)" v-if="accessory.status==2">Reject</b-button>                                     
                                    <b-button variant="danger" class="mt-2 mr-1 btn-sm" @click="deactivateVehicle(accessory)" v-if="accessory.status==1">Deactivate</b-button>

                                    <b-button variant="success" class="mt-2 mr-1 btn-sm" @click="activateVehicle(accessory)" v-if="accessory.status==0">Activate</b-button>                                   
                                 </td>
                              </tr>
                           </tbody>                           
                        </table>
                     </div>
                     <!--- Listing ends ------->                     

                     <!----pagination starts --->
                     <nav aria-label="Page navigation">                    
                        <ul class="pagination">
                           <li class="page-item" v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                              <a class="page-link" href="#" @click.prevent="fetchAccessories(page.url + '&limit='+ listing_length + '&keyword=' + keyword )" tabindex="-1">
                                 <span v-if="index == 0">Prev</span>
                                 <span v-else-if="index == pagination.length-1">Next</span>
                                 <span v-else>{{page.label}}</span>
                              </a>
                           </li>                        
                        </ul>
                     </nav>
                     <!----pagination ends --->                           

                  </template>
               </card>
          </b-col>
       </b-row>
    </b-container>
</template>
<script>
export default {
   name:'ViewAccessories',
   data() {
      return {
         accessories: [],        
         pagination: {},
         
         edit: false,
         accessory_status: {
            id: "",
            status: ""
         },
         keyword: '',
         listing_length: 10,
         
         token: '',
         errors: {},
         active_page_url: null,
      };
   },
   mounted () {
      
   },

   created() {
      this.fetchAccessories();
   },

   methods: {      

      fetchAccessories(page_url=null) {
         let url = '/api/admin/accessories?limit=' + this.listing_length + '&keyword=' + this.keyword;
         page_url = page_url || url;  

         if(localStorage.back_url) {
            //alert('check');
            page_url = localStorage.back_url;              
            localStorage.removeItem('back_url');
         }    

         this.active_page_url = page_url;      
            
         this.getToken();
         this.$axios
            .get(page_url,{headers: {Authorization: 'Bearer ' + this.token,}})
            .then(res => {
               var responseData = res.data.data;
               this.accessories = responseData.data;               
               this.pagination = responseData.links
               
            })
            .catch(err => console.log(err));
      },   

      getToken() {
         if(localStorage.token) {
            this.token = localStorage.token;
         } else {
            this.$vToastify.error('Session expired, please login again');
            this.$router.push({name: 'auth.login'})
         }
      },

      setBackURL(accessory_id) {
         localStorage.setItem('back_url', this.active_page_url);
         this.$router.push({ name: 'accessories.clicks', params: { id: accessory_id } });
      },
      
      approveVehicle(accessory) {
         let change_status = false;
         this.$bvModal.msgBoxConfirm('Are you sure you want to approve this ad?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
         })
         .then(value => {
            change_status = value
            if(change_status){
               this.accessory_status.id = accessory.id;
               this.accessory_status.status = '1';
               this.updateVehicleStatus(1);
            }
         })
         .catch(err => {
            console.log(err);
         })
      },
      rejectVehicle(accessory) {
         let change_status = false;
         this.$bvModal.msgBoxConfirm('Are you sure you want to reject this ad?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
         })
         .then(value => {
            change_status = value
            if(change_status){
               this.accessory_status.id = accessory.id;
               this.accessory_status.status = '3';
               this.updateVehicleStatus(1);
            }
         })
         .catch(err => {
            console.log(err);
         })
      },
      activateVehicle(accessory) {
         let change_status = false;
         this.$bvModal.msgBoxConfirm('Are you sure you want to activate this ad?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
         })
         .then(value => {
            change_status = value
            if(change_status){
               this.accessory_status.id = accessory.id;
               this.accessory_status.status = '1';
               this.updateVehicleStatus();
            }
         })
         .catch(err => {
            console.log(err);
         })
      },
      deactivateVehicle(accessory) {
         let change_status = false;
         this.$bvModal.msgBoxConfirm('Are you sure you want to deactivate this ad?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
         })
         .then(value => {
            change_status = value
            if(change_status){
               this.accessory_status.id = accessory.id;
               this.accessory_status.status = '0';
               this.updateVehicleStatus();
            }
         })
         .catch(err => {
            console.log(err);
         })
      },
      updateVehicleStatus(approval = 0) {
         const config = {
              headers: {
                  'Authorization': 'Bearer ' + this.token,
              }
         };
         let url;
         if(approval) {
            url = '/api/admin/accessories/approve?accessory_id=';
         } else {
            url = '/api/admin/accessories/status?accessory_id=';
         }
         this.$axios
         .get(url + this.accessory_status.id + '&status=' + this.accessory_status.status, config)
         .then(response => {
              if(response.data.status) {
                  this.$vToastify.success(response.data.message);
              } else {
                  this.$vToastify.error(response.data.message);
              }
              this.fetchAccessories(this.active_page_url);
          })
          .catch(error => {
               if(error.response){
                  if(error.response.data.message){
                     this.$vToastify.error(error.response.message);
                  } else {
                     this.$vToastify.error("Error!");
                  }                  
               } else {
                  this.$vToastify.error("Error!");
               }
               
          });
      },
   }   
}
</script>